import React from 'react';
import { toast } from 'sonner';
import { CheckCircle, XCircle, X } from 'lucide-react';

const TOAST_DURATION_MS = 4000;

export function showSuccessToast(message: string): void {
  toast.custom(
    (toastId) => (
      <div className="flex items-center gap-3 rounded-lg border border-border bg-background px-4 py-3 shadow-lg w-[356px]">
        <CheckCircle className="h-5 w-5 text-emerald-500 flex-shrink-0" />
        <p className="flex-1 text-sm font-medium text-foreground">{message}</p>
        <button
          type="button"
          className="flex-shrink-0 text-muted-foreground hover:text-foreground"
          onClick={() => toast.dismiss(toastId)}
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    ),
    { duration: TOAST_DURATION_MS },
  );
}

export function showErrorToast(message: string): void {
  toast.custom(
    (toastId) => (
      <div className="flex items-center gap-3 rounded-lg border border-red-300 bg-red-50 px-4 py-3 shadow-lg w-[356px] dark:border-red-800 dark:bg-red-950">
        <XCircle className="h-5 w-5 text-red-500 flex-shrink-0" />
        <p className="flex-1 text-sm font-medium text-red-800 dark:text-red-200">{message}</p>
        <button
          type="button"
          className="flex-shrink-0 text-red-400 hover:text-red-600 dark:text-red-400 dark:hover:text-red-200"
          onClick={() => toast.dismiss(toastId)}
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    ),
    { duration: TOAST_DURATION_MS },
  );
}
